class AuthorizedDevice {
    public id: number;
    public device_name: string;
    public device_id: string;
    public is_active: boolean;
    public use_key: boolean;
    public key: string;
    public date_created: string;
    public date_vilidity: string;
    public date_comprobation: string;
    public id_ips__nombre_ips: string;
    public id_ips__municipio_id__nombre_municipio: string;
    public password_divice: string;
    public date_inactive: string;

    constructor(
        id: number,
        device_name: string,
        device_id: string,
        is_active: boolean,
        use_key: boolean,
        key: string,
        date_created: string,
        date_vilidity: string,
        date_comprobation: string,
        id_ips__nombre_ips: string,
        id_ips__municipio_id__nombre_municipio: string,
        password_divice: string,
        date_inactive: string
    ) {
        this.id = id;
        this.device_name = device_name;
        this.device_id = device_id;
        this.is_active = is_active;
        this.use_key = use_key;
        this.key = key;
        this.date_created = date_created;
        this.date_vilidity = date_vilidity;
        this.date_comprobation = date_comprobation;
        this.id_ips__nombre_ips = id_ips__nombre_ips;
        this.id_ips__municipio_id__nombre_municipio = id_ips__municipio_id__nombre_municipio;
        this.password_divice = password_divice;
        this.date_inactive = date_inactive;
    }
}
export default AuthorizedDevice;